import instance from "../apis/axiosConfig";

// CREATE FEEDBACK
export const createFeedback = (data) => {
  return instance.post("feedback/submit", data);
};

// GET ALL FEEDBACK (Pagination)
export const getFeedbacks = (page = 1, limit = 5) => {
  return instance.get(`feedback/list?page=${page}&limit=${limit}`);
};

// UPDATE DETAILS
export const updateFeedback = (id, data) => {
  return instance.post(`feedback/update/${id}`, data);
};

// DELETE
export const deleteFeedback = (id) => {
  return instance.delete(`feedback/delete/${id}`);
};

// UPDATE IMAGE
export const updateFeedbackImage = (id, data) => {
  return instance.post(`feedback/update-image/${id}`, data);
};

// UPDATE PUBLISH STATUS
export const updatePublishStatus = (id, data) => {
  return instance.post(`feedback/update-publish-status/${id}`, data);
};

// UPDATE PRIORITY
export const updateFeedbackPriority = (data) => {
  return instance.post("feedback/priority", data);
};